<template>
  <v-sheet class="pa-4" elevation="2" rounded>
      <v-form ref="form" lazy-validation>
    <div>
      <v-autocomplete
        :items="teachers"
        v-model="selectedTeacherId"
        item-text="name"
        item-value="id"
        label="Choose a teacher for this schedule"
        :rules="[rules.required]"
        @change="changeTeacher"
      >
      </v-autocomplete>
      <v-radio-group
        v-if="recurring"
        v-model="assignTeacherMode"
        row
        label="Assign to "
      >
        <v-radio value="single" :label="`${formatDate(scheduleDate)} Only`" />
        <v-radio
          value="dateplus"
          :label="`Starting from ${formatDate(scheduleDate)}`"
        />
        <v-radio value="recurring" label="All dates on the schedule" />
      </v-radio-group>
      <v-select
        v-model="rate"
        :items="hourlyRates"
        item-value="id"
        item-text="hourlyRate"
        label="Teaching hourly rate"
        clearable
      >
        <template v-slot:item="{ item }">
          {{ item.hourlyRate | currency }}
        </template>
        <template v-slot:selection="{ item }">
          {{ item.hourlyRate | currency }}
        </template>
      </v-select>
      <v-text-field
        label="Paid prep time in minutes"
        v-model="prepTimeInMins"
        type="number"
        min="0"
      />
      <v-textarea v-model="remark" outlined label="Remark (Optional)" />
    </div>
    <div class="text-center">
      <v-btn class="my-2" small @click="assignTeacher"> Assign Teacher </v-btn>
    </div>
      </v-form>
  </v-sheet>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import { rules } from "@/store/util/rules.js";


export default {
    props:{
        scheduleId:{
            type: Number,
            required: true,
        },
        scheduleDate:{
            type: [String, Date],
            required: false
        },
        recurring:{
            type: Boolean,
            required: false,
            default: false,
        },
    },
  data() {
    return {
      assignTeacherMode: "recurring",
      teachers: [],
      selectedTeacherId: null,
      teacher: null,
      prepTimeInMins: 0,
      hourlyRates: [],
      rate: null,
      remark: null,
      rules
    };
  },
  mounted(){
      this.loadTeachers()
        .then((teachers) => {
            this.teachers = teachers;
        })
  },
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage", "addMessage"]),
    formatDate(value) {
      return moment(value).format("ddd, MMM DD YYYY");
    },
    async loadTeachers() {
      const data = {
        pageSize: 1000,
        sortInfos: [{ sortCol: "firstName", sortDir: "asc" }],
        registered: true,
      };

      return await this.$axios
        .post("/teacher/search", data)
        .then((resp) => {
          return resp.data.data.content.map((t) => {
            return Object.assign({ name: `${t.firstName} ${t.lastName}` }, t);
          });
        })
        .catch(() => {
          this.addErrorMessage("Error loading teachers from server");
        });
    },
    async getTeacher(teacherId){
        const params = {
            teacherId
        }
        return await this.$axios.get('/teacher/getById', {params})
            .then( (resp) => {
               return resp.data.data;
            })
    },
    changeTeacher(){
        this.getTeacher(this.selectedTeacherId)
            .then( (t) => {
                console.log(t);
                this.teacher = t;
                this.hourlyRates = t.hourlyRates;
                if(this.hourlyRates && this.hourlyRates.length > 0){
                    this.rate = this.hourlyRates[0].id;
                }
            })
    },
    assignTeacher() {
      if(!this.$refs.form.validate()){
        this.addMessage('Please check your input');
        return;
      }

      let date = null;
      if(this.scheduleDate){
        date = moment(this.scheduleDate).format("YYYY-MM-DD");
      }

      const data = {
        courseScheduleId: this.scheduleId,
        teacherId: this.selectedTeacherId,
        date: this.assignTeacherMode != "recurring" && date ? date : null,
        assignMode: this.assignTeacherMode,
        add2GoogleEvent: true,
        rateId: this.rate,
        paidPrepTimeInMins: this.prepTimeInMins,
        remark: this.remark
      };
      this.$axios.post("/course-schedule/assign-teacher", data).then((resp) => {
        const teacherSchedule = resp.data.data;
        this.addSuccessMessage("Teacher assigned");
        this.$emit('assignedTeacher', teacherSchedule);
      })
        .catch( (error) =>{
            this.addErrorMessage(error.data.message || "Error assigning teacher to schedule");
        })
    },
  },
};
</script>

<style>
</style>